import React, { useState, useEffect, Suspense } from 'react';
import ModalDialog, { DialogContent } from '../../AlmeDialog/ModalDialog';
import styled from 'styled-components';
import SyfLoader from 'syf-component-library/ui/atoms/Loader/SyfLoader';
import { loadTransmitDependencies } from './loadTransmitDeps';
import ErrorBoundary from '../../ErrorBoundary/ErrorBoundary';
import transmitConfig from './config/iva-app.json';
import { getLogger } from '../../../utils/DebugUtils';
const configJson = JSON.stringify(transmitConfig);
// eslint-disable-next-line @typescript-eslint/no-unsafe-return
const TransmitWebSDKEnterpriseAuth = React.lazy(() => import('syf-transmit-iva/dist/TransmitWebSDKEnterpriseAuth'));
const TransmitDialogContent = styled(DialogContent) `
padding: 1em;
`;
const TransmitFormOverlay = (props) => {
    const [loadedState, setLoadedState] = useState(() => ({ loaded: false, params: null }));
    const [isOpen, setIsOpen] = useState(true);
    const handleAuthResponse = async (response) => {
        const transmitResult = {
            TransmitResultObject: response,
        };
        await props.onTransmitAuthComplete('TransmitResult', transmitResult, 'Internal');
        setIsOpen(false);
    };
    useEffect(() => {
        if (!loadedState.loaded) {
            loadTransmitDependencies(props.responseAction.TransmitStartParams, props.appConfig, (transmitParams) => {
                setLoadedState({ loaded: true, params: transmitParams });
            }, (e) => {
                getLogger(props.appConfig.UiLogLevel).error("Unable to load transmit dependencies", e);
                setIsOpen(false);
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadedState]);
    if (!isOpen) {
        return null;
    }
    return (React.createElement(ErrorBoundary, { appConfig: props.appConfig },
        React.createElement(ModalDialog, { id: 'data-collection-dialog', ariaLabel: "User authentication dialog" },
            React.createElement(TransmitDialogContent, null, loadedState.loaded
                ? React.createElement(Suspense, { fallback: React.createElement(SyfLoader, { size: 5 }) },
                    React.createElement(TransmitWebSDKEnterpriseAuth, { config: configJson, params: loadedState.params, handleAuthResponse: handleAuthResponse }))
                : React.createElement(SyfLoader, { size: 5 })))));
};
export default TransmitFormOverlay;
